<form [formGroup]="formGroup">
    @for (field of fields(); track field.guid) {
        @if (workspacesDictionary()[field.workspace_guid!]; as workspace) {
            <ng-container
                *ngTemplateOutlet="fieldItem; context: { field, workspace }"
            ></ng-container>
        } @else if (showSystemField(field)) {
            <ng-container
                *ngTemplateOutlet="fieldItem; context: { field, workspace: globalWorkspace }"
            ></ng-container>
        }
    }

    <ng-template #fieldItem let-field="field" let-workspace="workspace">
        <div class="flex max-sm:flex-col items-center mt-2 sm:mb-0 max-sm:mb-4 max-sm:gap-4">
            <div class="flex justify-left items-center max-sm:w-full w-[12.25rem] pr-4 shrink-0">
                <app-field-name
                    [field]="field"
                    [showIcon]="true"
                    [iconColor]="workspace.color.value"
                >
                </app-field-name>
                @if (field.is_required) {
                    <app-tb-icon
                        icon="asterisk"
                        color="textLight"
                        class="icon-xs ml-[0.125rem]"
                    ></app-tb-icon>
                }
                @if (field.is_on_top) {
                    <app-tb-icon
                        icon="upgrade"
                        color="textLight"
                        class="icon-xs ml-[0.125rem]"
                    ></app-tb-icon>
                }
            </div>
            <app-record-fields-input
                [fieldTypes]="fieldTypes()"
                [field]="field"
                [record]="record()"
                [fieldValueFormControl]="getFieldFormControl(field.guid)"
                [inputAppearance]="inputAppearance()"
                [hoverIcons]="hoverIcons()"
                class="relative flex items-center min-w-0 w-full grow"
            ></app-record-fields-input>
        </div>
    </ng-template>
</form>
